export default __webpack_public_path__ + "static/hero-95df1189e37dc4030954c8babfe11d7c.png";